export default __webpack_public_path__ + "static/media/indra-eye.ef3bc8fe.png";